export const FhirEpicProjectId_Local = 'quai-local';
export const FhirEpicProjectId_Dev = 'quai-md-km-dev';
export const FhirEpicProjectId_Staging = 'quai-md-km-staging';
export const FhirEpicProjectId_Prod = 'quai-md-km';
export const DefaultFhirEpicKeyLadder = [
    { env: 'local', projectId: FhirEpicProjectId_Local },
    { env: 'dev', projectId: FhirEpicProjectId_Dev },
    { env: 'staging', projectId: FhirEpicProjectId_Staging },
    { env: 'prod', projectId: FhirEpicProjectId_Prod },
];
export const FhirEpicEnvLabelMap = {
    local: 'Local',
    dev: 'Dev',
    staging: 'Staging',
    prod: 'Prod',
};
//# sourceMappingURL=consts.js.map